import { Expiry } from './createCustomerCreditGrant.validation'

export const EXPIRY_OPTIONS: Array<{ label: string; value: Expiry }> = [
  { label: 'No expiry', value: 'NEVER' },
  { label: 'On a date', value: 'ON_DATE' }
]

export const DATE_FORMAT = 'd MMM yyyy'
